import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { ExtendedConfigResponse } from './Publists';
import { UsersDTO } from '../../../api/admin';
import { ConfigResponse, PublistShareApi } from '../../../api/core';
import { getAuthMiddleware } from '../../../Auth/utils/GetAuthMiddleware';
import { AuthContext } from '../../../Auth/components/AuthProvider';
import { LabelledUserSuggester } from './LabelledUserSuggester';
import { Labelled } from '../../components/form/Labelled';

interface Props {
  visible: boolean;
  onHide: () => void;
  data: ExtendedConfigResponse[];
  updateData: () => void;
}


export const ShareDialog = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const {actions} = useContext(AuthContext);
  const shareServiceApi: PublistShareApi = new PublistShareApi().withMiddleware(getAuthMiddleware(actions));

  return <Dialog header={intl.formatMessage({id: 'user.profile.publist.popup.share.share_with'})}
                 visible={props.visible}
                 style={{width: '100%', maxWidth: '1000px'}}
                 closeOnEscape={true}
                 dismissableMask={true}
                 onHide={(): void => props.onHide()}>
    <div className={'m-0 flex flex-column gap-4'}>
      <Labelled id={'lists'} title={'user.profile.publist.popup.share.share_with.lists'}>
        <div className={'flex flex-column gap-1'}>
          {props.data.map((item: ExtendedConfigResponse) => (
            <span>{item.config.name || intl.formatMessage({id: 'publist.unnamedPublist'})} ({item.apiKey})</span>
          ))}
        </div>
      </Labelled>
      <LabelledUserSuggester
        title={'user.profile.publist.popup.share.share_with.add'}
        value={[]}
        onChange={(users: UsersDTO[]): void => {
          users.forEach((user: UsersDTO): void => {
            void shareServiceApi.addShareWith({
              shareRequestBody: {
                apiKeys: props.data.map((item: ExtendedConfigResponse): string => item.apiKey),
                destinationUser: user.id,
              },
            }).then((response: ConfigResponse[]): void => props.updateData());
          });
        }}
        multiple={false} id={'adduser'}/>
      <Labelled id={'currentusers'} title={'user.profile.publist.popup.share.share_with.current'}>
        {
          props.data
            .map((item: ExtendedConfigResponse, index: number): UsersDTO[] => item.shareUsers.sharedWith)
            .flat()
            .filter((item: UsersDTO, index: number, array: UsersDTO[]): boolean => array.indexOf(item) === index)
            .map((item: UsersDTO, index: number): ReactNode =>
              <div key={`user${item.id}`} className={'flex justify-content-between'}>
                <p>{`${item.givenname} ${item.surname}`}</p>
                <Button severity={'danger'} icon={'pi pi-trash'} onClick={(): void => {
                  void shareServiceApi.deleteShareWith({
                    shareRequestBody: {
                      apiKeys: props.data.map((extendedConfigResponse: ExtendedConfigResponse): string => extendedConfigResponse.apiKey),
                      destinationUser: item.id,
                    },
                  }).then((response: ConfigResponse[]): void => props.updateData());
                }}/>
              </div>,
            )
        }
      </Labelled>
    </div>
  </Dialog>;
};
